import { connect } from 'react-redux'
import Login from '../components/Login'
import { reduxForm } from 'redux-form'
import { browserHistory } from 'react-router'

import { login } from '../../user/UserActions'


import request from '../../utils/request'


const config = {
    form: 'LoginForm',
    onSubmit: (values, dispatch, props) => {
       return dispatch(login(values))
    }
}

export default connect(null, null)(reduxForm(config)(Login))



// WEBPACK FOOTER //
// ./src/home/containers/LoginContainer.js